export const MAX_PROJECT_QUESTIONS_COUNT = 50;
